// extracted by mini-css-extract-plugin
module.exports = {"root":"FormPage_root__1zxHR","content":"FormPage_content__2c3vc","title":"FormPage_title__3AOsa","description":"FormPage_description__2nSZh"};